export const STORAGE_ADMIN_PAGE_INDEX = 'StorageAdmin/Index'

export default [
  {
    name: STORAGE_ADMIN_PAGE_INDEX,
    path: '/storage-admin',
    component: () => import('./Index.vue'),
    meta: {
      authRequired: true,
      showNavbar: true,
      title: 'Histórico Guarda Volumes',
      label: 'Histórico Guarda Volumes',
      roles: ['Admin', 'Master', 'Operator']
    }
  }
]
